import axios from "axios";
import { BaseService } from "../BaseService";

export class ChatsTutorialService extends BaseService {
  async listSteps(): Promise<any> {
    try {
      return this.handleResponse(await axios.get(`/mock/tutorial.json`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }
}
